module.exports = __webpack_public_path__ + "static/media/icon-9.3b327df7.png";